export interface CompleteParams {
}

const Complete = ({
}: CompleteParams) => {
    return (
        <div>
            <p>
                Complete
            </p>
        </div>
    );
};

export default Complete;
